import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

// Proper SPA 404. Previously unknown routes redirected to /login, whose
// "noindex" meta made Google exclude legitimate URLs from the index.
const NotFound = () => (
  <div className="min-h-screen bg-white flex items-center justify-center px-4">
    <Helmet>
      <title>Page Not Found | FBRSTAPP</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="text-center max-w-md">
      <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">Page not found</h2>
      <p className="text-gray-600 mb-8">
        The page you are looking for does not exist or has moved.
      </p>
      <div className="flex items-center justify-center gap-3">
        <Link to="/" className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium">
          Go to Home
        </Link>
        <Link to="/blog" className="px-6 py-2 text-blue-600 hover:text-blue-700 font-medium">
          Read the Blog
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
